import { createContext, useContext } from 'react';

export type CollapseStatus = 'entering' | 'entered' | 'exiting' | 'exited';

type CollapseContextValue = {
  status: CollapseStatus;
  setStatus: (next: CollapseStatus) => void;
};

const defaultContextValue: CollapseContextValue = {
  status: 'entered',
  setStatus: () => {},
};

const CollapseContext =
  createContext<CollapseContextValue>(defaultContextValue);

export const CollapseProvider = CollapseContext.Provider;

export const useCollapseContext = () => useContext(CollapseContext);
